"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundPackageCreator = void 0;
var InboundPackageCreator;
(function (InboundPackageCreator) {
    InboundPackageCreator["SELLER"] = "SELLER";
    InboundPackageCreator["CROSSDOCK_NON_COMPLIANCE"] = "CROSSDOCK_NON_COMPLIANCE";
    InboundPackageCreator["CROSSDOCK_BOX_BREAKS"] = "CROSSDOCK_BOX_BREAKS";
    InboundPackageCreator["CROSSDOCK_SBL"] = "CROSSDOCK_SBL";
    InboundPackageCreator["PREP"] = "PREP";
    InboundPackageCreator["RETURNS"] = "RETURNS";
    InboundPackageCreator["SHOPIFY_PLACEHOLDER"] = "SHOPIFY_PLACEHOLDER";
    InboundPackageCreator["SHOPIFY_API"] = "SHOPIFY_API";
    InboundPackageCreator["TEST"] = "TEST";
    InboundPackageCreator["NON_COMPLIANCE"] = "NON_COMPLIANCE";
    InboundPackageCreator["ATTRIBUTION_ALGORITHM"] = "ATTRIBUTION_ALGORITHM";
})(InboundPackageCreator = exports.InboundPackageCreator || (exports.InboundPackageCreator = {}));
//# sourceMappingURL=InboundPackageCreator.js.map